module.exports = __webpack_public_path__ + "img/sport.0e338f68.svg";